import { Utensils } from 'lucide-react';

/** 画布「品题」入口图标（Lucide utensils） */
export function TtqPinTiIcon({ size = 14 }: { size?: number }) {
  return <Utensils size={size} strokeWidth={2} aria-hidden />;
}
